import { isFeatureEnabled } from 'owa-feature-flags';
import CategoryColor from '../store/schema/CategoryColor';
import { DEFAULT_NEW_CATEGORY_COLOR_CODE } from './categoriesConstants';

// This is the default category color when picking a color for a new category
export default function getDefaultCategoryColorString() {
    return isFeatureEnabled('tri-newCategoryCreation')
        ? CategoryColor.Red.toString()
        : DEFAULT_NEW_CATEGORY_COLOR_CODE.toString();
}
